/*
 * @Author: your name
 * @Date: 2021-04-27 10:12:02
 * @LastEditTime: 2021-05-12 14:11:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /hdl-open-pc/src/index.tsx
 */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './router/index'
import { Router, Route } from 'react-router'
import { createHashHistory } from 'history'
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux'
import store from './store'
import './index.css';
import './assets/css/reset.min.css'
import './assets/css/common.scss'
import Index from './pages/Home/index'
import Users from './pages/Users';
moment.locale('zh-cn');
const history = createHashHistory();
ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={zhCN}>
      <App name="海底捞开放平台" />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

